/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { imageatch_detApi } from '../api/imageatch_det.api';
import { switchMap, map } from 'rxjs/operators';
import { imageatch_detData, imageatch_det } from '../../../interfaces/masters/imageatch_det';


@Injectable()
export class imageatch_detService extends imageatch_detData {

  constructor(private api: imageatch_detApi) {
    super();
  }



  list(url: string): Observable<imageatch_det[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<imageatch_det>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable<any> {
    return this.api.add(url,data);
  }

  update(url: string, data:imageatch_det): Observable<imageatch_det> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

 
}
